/**
 * 登录注册模块接口列表
 */

import base from './base'; // 导入接口域名列表
import axios from '../utils/http'; // 导入http中创建的axios实例

const article = {
	//提交客户信息
	commit(data) {
		return axios.post(`${base.system}/workOrder/submit`,data);
	},
	//获取全部新闻
	getAllNews(data) {
		return axios.get(`${base.system}/news/page?PageNo=`+data.pageNo+'&PageSize=3');
	},
	//获取新闻模块
	getAllModule() {
		return axios.get(`${base.system}/module/getreleased`);
	},	
	//获取版块新闻
	getModuleNews(data) {
		return axios.get(`${base.system}/news/modulenews?PageNo=`+data.pageNo+'&PageSize=3&ModuleId='+data.integer);
	},
	//获取新闻详情
	getNewsDetail(data) {
		return axios.get(`${base.system}/news/get?id=`+data.id);
	},
	
};
export default article;
